import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { useUser } from '../generic/hooks/useUser'
import SmartMateriaUITable from '../generic/SmartMateriaUITable'

const DeviceBooker = () => {
  const { user } = useUser()
  const { t_ } = useSmartTranslation()

  if (!user || !user.profile || user.profile.code !== 'SUPERADMIN') {
    return null
  }

  const columns = [
    {
      field: 'deviceId',
      name: t_('Id')
    },
    {
      field: 'deviceName',
      name: t_('Name')
    },

    {
      field: 'locked',
      name: t_('Booked'),
      type: 'boolean'
    },
    {
      field: 'canBeUnlocked',
      name: t_('Can be unlocked'),
      type: 'boolean'
    }
  ]

  return (
    <SmartMateriaUITable
      title={t_('Device booker')}
      dataFetch='debug/deviceBookedInfoList'
      columns={columns}
    />
  )
}

export default DeviceBooker
